<template>
  <div class="container">
    <img alt="Anima logo" src="../assets/logo.png" />
    <h3>Anima Admin</h3>
    <div v-if="showNormalLogin">
      <form action="#" @submit.prevent="login" class="container login">
        <el-input v-model="username" type="email" placeholder="Email" />
        <el-input
          v-model="password"
          type="password"
          placeholder="Password"
          show-password
        />
        <el-button
          native-type="submit"
          type="primary"
          v-loading="loading.auth || loading.admin"
          >Login</el-button
        >
      </form>
      <el-divider> Or </el-divider>
    </div>

    <GoogleButton
      @click="onGoogleLoginClick"
      @success="onGoogleLoginSuccess"
      @failure="onGoogleLoginFailure"
    >
      Log in with Google
    </GoogleButton>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
import GoogleButton from "@/components/GoogleButton";
import googleAuth from "@/services/googleAuth";

export default {
  data() {
    return {
      username: "",
      password: "",
    };
  },
  components: {
    GoogleButton,
  },
  computed: {
    ...mapGetters(["loading", "admin"]),
    showNormalLogin: function () {
      return process.env.NODE_ENV !== "production";
    },
  },
  methods: {
    ...mapActions(["getToken", "getAdmin", "setGoogleToken"]),
    ...mapMutations(["setLoading", "unsetLoading"]),
    async login() {
      const { username, password } = this;
      if (!username || !password) {
        this.$message.error("Please insert email and password.");
        return;
      }

      try {
        await this.getToken({ username, password });
        await this.getAdmin();
        this.$router.push("/");
      } catch (e) {
        console.error(e);
        this.$message.error(
          "Something went wrong. Please check your credentials."
        );
      }
    },
    onGoogleLoginClick() {
      this.setLoading("auth");
    },
    async onGoogleLoginSuccess(googleUser) {
      const { access_token } = await googleAuth.googleLogin(googleUser);
      await this.setGoogleToken(access_token);
      await this.getAdmin();
      this.unsetLoading("auth");
      if (!this.admin) {
        this.$message.error("Loooks like you're not an Anima Admin.");
        this.$store.commit("logout");
        return;
      }
      this.$router.push("/");
    },
    async onGoogleLoginFailure(err) {
      this.unsetLoading("auth");
      console.error(err);
      this.$message.error(
        "Something went wrong. Please check your credentials."
      );
    },
  },
};
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.container img {
  height: 100px;
}
.container.login {
  width: 300px;
}
.container.login * {
  margin: 5px;
}
</style>
